module.exports = __webpack_public_path__ + "static/caf91-logo-f1e959e60e374143da23912592853989.png";